export default __webpack_public_path__ + "img/not-authorized.8c37fd62.png";